<template>
  <v-row class="mx-n4">
    <v-col cols="7" class="mx-n4">
      <v-card-title>{{ label }}</v-card-title>
    </v-col>

    <v-col cols="6" class="mt-n9">
      <v-btn x-small @click="prettify"><v-icon>code</v-icon> </v-btn>
    </v-col>

    <v-col cols="11" class="mt-n4">
      <prism-editor v-model="newValue" class="my-editor" :highlight="highlighter" line-numbers />
    </v-col>

    <v-col cols="8" class="mb-n3 mx-1 mt-n6 json-error">
      <p>{{ validateJSON }}</p>
    </v-col>
  </v-row>
</template>

<script setup>
import { ref, watch } from 'vue';

import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css'; // import syntax highlighting styles

// eslint-disable-next-line no-undef
const emit = defineEmits(['input']);

// eslint-disable-next-line no-undef
const props = defineProps({
  value: { type: [Array, Number, String], default: null },
  label: { type: String, default: 'Données JSON personnalisées' }
});

const newValue = ref(props.value);
const validateJSON = ref('');

const prettify = () => newValue.value = newValue.value ? JSON.stringify(JSON.parse(newValue.value), 0, 3) : '';

const highlighter = code => highlight(code, languages.js, 'json');

watch(newValue, value => {
  try {
    JSON.parse(value);
    // reset error
    validateJSON.value = '';
    emit('input', value || null);
  } catch (e) {
    validateJSON.value = e.message;
  }
});
</script>

<style lang="scss" scoped>
/* required class */
.my-editor {
  /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
  background: #2d2d2d;
  color: #ccc;

  /* you must provide font-family font-size line-height. Example: */
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
}

.json-error {
  color: #EF5350;
  font-size: 95%;
}
</style>
